/**
 * @generated SignedSource<<f9e3b576da69899eb3d10f5f0c065c11>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SocialLinksEditDialog_User$data = {
  readonly profile: {
    readonly urlBlog: string | null | undefined;
    readonly urlDribbble: string | null | undefined;
    readonly urlGithub: string | null | undefined;
    readonly urlLinkedin: string | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "SocialLinksEditDialog_User";
};
export type SocialLinksEditDialog_User$key = {
  readonly " $data"?: SocialLinksEditDialog_User$data;
  readonly " $fragmentSpreads": FragmentRefs<"SocialLinksEditDialog_User">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SocialLinksEditDialog_User",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Profile",
      "kind": "LinkedField",
      "name": "profile",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "urlBlog",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "urlDribbble",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "urlGithub",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "urlLinkedin",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "f3de71d78659b3bf2ae352d47fd4ef4d";

export default node;
